import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../../config/index";

const baseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  mode: "cors",
  credentials: "same-origin",

  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.authReducer?.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    updateImage: builder.mutation({
      query(data) {
        return {
          url: "/upload/image-gallery",
          method: "PATCH",
          body: data,
        };
      },
    }),
  }),
});

export const { useUpdateImageMutation } = apiSlice;
